/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react"
import { Link } from "react-router-dom"
import { OVERVIEW_PAGE_CONTENT } from "../constants"
import { getAssetPath } from "../../../utils/assets"

function MatchfitDashboardEmptyState({ unfinishedSurveyExists }) {
  return (
    <div className="dashboard-body">
      <div className="container dashboard" id="dashboard-10dwc">
        <div className="d-flex align-items-center justify-content-between my-4">
          <img src={getAssetPath(OVERVIEW_PAGE_CONTENT.matchfit.logoAssetName)} />
        </div>
        <div className="row text-center justify-content-center">
          <div className="col-lg-8">
            {/* TODO: change the content with th official */}
            <h1 className="mb-4">
              Welcome to the MatchFit Calculator
            </h1>
            <p>
              An anonymised version of the data collected in this survey will be shared with the Performance Intelligence Research Institute for research purposes.
            </p>
            <Link className="btn btn-link" to="/about-matchfit">What is Matchfit?</Link>
            <div className="text-center mt-5">
              <Link className="btn btn-main" to="/matchfit/intro">{`${unfinishedSurveyExists ? "Start" : "Continue"} Survey`}</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default MatchfitDashboardEmptyState
